import { Info } from "lucide-react";
import type { ReactNode } from "react";

export interface NotesListProps {
  readonly notes: readonly string[];
}

// Renders meta.notes verbatim — the mandatory honesty caveats that travel with every payload.
export const NotesList = ({ notes }: NotesListProps): ReactNode => {
  if (notes.length === 0) {
    return null;
  }
  return (
    <ul className="note-list">
      {notes.map((note) => (
        <li key={note}>
          <Info className="icon" size={13} aria-hidden />
          <span>{note}</span>
        </li>
      ))}
    </ul>
  );
};
